import { AvailableProductsResponse } from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';
import { ConfirmationPageTemplate } from '@/templates/ondemand/signup/confirmation/confirmation-page/src/confirmation-page.template';

import { getFeatureFlagValues } from '../../../../wac-routes';

export type ConfirmationPageProps = {
	availableProducts: AvailableProductsResponse | null | undefined;
};

export const ConfirmationPage = ({ availableProducts }: ConfirmationPageProps) => {
	return (
		<ConfirmationPageTemplate
			featureFlags={window.featureFlags || getFeatureFlagValues(window.location.search.split('&'))}
			isProduction={process.env['CLIENT_LIBRARY_ENV'] === 'production'}
			availableProducts={availableProducts ?? undefined}
		/>
	);
};
